const footerDate = () => {
    //порабоать с этим позже
    let date = new Date().getFullYear();
    console.log(date);
    let footerP = $('#copyright').innerText;
    console.log(footerP);
    
    
}

export default footerDate;